module.exports = __webpack_public_path__ + "images/8d355e364d9ccd12d76561d93c71bb06-illu_panicPendant.svg";